export default class Wishlist {
   constructor() {
      // define functions
      this.init = this.init.bind(this);
      this.updateWishlist = this.updateWishlist.bind(this);
      this.fetchProduct = this.fetchProduct.bind(this);
      this.binds = this.binds.bind(this);
   }

   binds(){
      const par = this;

      $('.heart').off('click').on('click', function(e){
         e.preventDefault();
         let id = $(this).data('product-id');
         let wishlist = [];
         try {
            wishlist = JSON.parse(localStorage.getItem('wwwContempWishlist'))||[];
         } catch(err) {
            // console.log(err);
         };
         let index = wishlist.indexOf(id);
         if(index == -1) {
            wishlist.push(id);
         } else {
            wishlist.splice(index, 1);
         }
         localStorage.setItem('wwwContempWishlist', JSON.stringify(wishlist));
         $(this).toggleClass('active');
         
         par.updateWishlist();
      });
      
      $('a[href="#wishlist"]').off('click').on('click', function(e){
         e.preventDefault();
         $('html').toggleClass('wishlist-open');
      });
      
      $('.wishlist--close').off('click').on('click', function(e){
         e.preventDefault();
         $('html').removeClass('wishlist-open');
      });
   }

   init(){
      const par = this;

      par.binds();

      par.updateWishlist();
   }

   updateWishlist(){
      const par = this;
      var wishlist = [];
      try { 
         wishlist = JSON.parse(localStorage.getItem('wwwContempWishlist'))||[];
      } catch(err) {
         // console.log(err);
      }

      $('.wishlist--inner').html('');

      if(!wishlist || wishlist.length == 0) {
         $('.wishlist--inner').html('<p>Your wishlist is empty</p>');
         $('a[href="#wishlist"]').removeClass('active');
         $('.heart').removeClass('active');
      } else {
         wishlist.forEach(function(id){
            par.fetchProduct(id);
         });
      
         $('a[href="#wishlist"]').addClass('active');

         $('.heart').each(function(){
            let id = $(this).data('product-id');
            let wishlist = JSON.parse(localStorage.getItem('wwwContempWishlist')) || [];
            let index = wishlist.indexOf(id);
            // console.log(wishlist);
            if(index != -1) {
               $(this).addClass('active');
            }
         });
      }
}

   fetchProduct(id){
      const par = this;
 
      if(!id) return;

      fetch('/products/'+id+'.js')
         .then(response => response.json())
         .then(data => {
            // console.log(data);
            $('.wishlist--inner').append(`
               <li class="wishlist--item product-item">
                  <a href="${data.url}" class="wishlist--image">
                     <img src="${data.featured_image}" alt="${data.title}">
                  </a>
                  <div class="product-item--info">
                     <h4>${data.vendor}</h4>
                     <a href="${data.url}" class="wishlist--title">
                     <h3>${data.title}
                     </h3></a>
                     <div class="product-price">${
                        window.Shopify.formatMoney(data.price, window.Shopify.money_format)
                     }</div>
                     <span class="heart heart-bg" data-product-id="${ data.handle }"></span>
                  </div>
               </li>
            `);

            par.binds();
         })
      .catch(error => console.error('Error fetching product:', error));
   }
}